module.exports = __webpack_public_path__ + "static/bg2-d03f60f1bcc92450c586c9ab566db1d2.png";